import Vue from 'vue';

const EventBus = new Vue();
export default EventBus;



// WEBPACK FOOTER //
// ./src/events/event-bus.js